<template>
  <div>
    <headers></headers>
    <div class="bg">
      <div class="swiper">
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="item in 4" :key="item">
            <el-image :src="banner"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <middles activeIndex="/courseware"></middles>
    <div class="classify">
      <div class="w_1400">
        <div class="classify-box">
          <div class="item" v-for="(item,index) in filterList">
            <div>{{item.title}}</div>
            <ul>
              <!-- <li :class="item.select==key?'active':''" v-for="(res,key) in item.value" @click="item.select=key">
                <a href="javascript:;">{{res}}</a>
              </li> -->
              <el-tag :effect="item.select==0?'dark':'plain'" :type="item.select==0?'success':'info'" @click="tagchange(index,0)">
                全部
              </el-tag>
              <div>
                <el-tag v-for="(tag,key) in item.value" :key="key" v-if="tag" :effect="item.select==key?'dark':'plain'" :type="item.select==key?'success':'info'" @click="tagchange(index,key)">
                  {{tag}}
                </el-tag>
              </div>
            </ul>
          </div>


        </div>
      </div>
    </div>

    <div class="list-course">
      <div class="w_1400">

        <ul v-if="courseList.length!=0">
          <li v-for="item in courseList" @click="godet(item.id)">

              <div class="list-course-img">
                <img :src="item.image" alt="">
                <!-- <span>47节</span> -->
              </div>
              <div class="list-course-txt">
                <h3>
                  <!-- <span><i>{{item.teacher.nickname[0]}}</i>{{item.teacher.nickname.substring(1,item.teacher.nickname.length)}}</span> -->
                  {{item.name}}
                  </h3>
                <p><span>{{item.visitors}}</span>人观看</p>
              </div>
          </li>
        </ul>
        <el-empty description="我的课件为空" v-else></el-empty>
      </div>
    </div>
    <div style="text-align: center;">
      <el-pagination layout="prev, pager, next" :total="total" @next-click="nextpage" @prev-click="prevpage"
        :page-size="pageSize" @current-change="currentchange">
      </el-pagination>
    </div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from '../../components/headers.vue';
  import footers from '../../components/footers.vue';
  import middles from '../../components/middles.vue';
  import {
    courselist,
    getSelect,
    traininglist,
    allList,
    teachercoursedetail
  } from '../../request/api';
  export default {
    name: 'app',
    components: {
      headers,
      footers,
      middles
    },
    data() {
      return {
        banner: require('../../assets/banner1.png'),
        courseList: [],
        total: 0,
        filter: {},
        page: 1,
        pageSize : 12,
        filterList: '',
        tralist:'',
        page1:1,
        courseshow:true
      }
    },
    methods: {
      traininglist(){
        traininglist({page:this.page1,pageSize:12}).then(res=>{
          this.tralist=res.data.data
        })
      },
      godet(id){
        this.$router.push({
          name: 'coursewaredet',
          query: {
            id
          }
        })
      },
      tagchange(index,key){
        if(key!=0){
          this.filterList[index].select=key
          this.filter[this.filterList[index].name]=key
          this.courselist()
        }else{
          this.filterList[index].select=key
          this.filter[this.filterList[index].name]=undefined
          this.courselist()
        }
      },
      courselist() {
        courselist({
          page: this.page,
          pageSize: this.pageSize,
          filter: JSON.stringify(this.filter)
        }).then(res => {
          if (res.code) {
            this.courseList = res.data.data
            this.total = res.data.total
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 点击了下一页时触发的方法
      nextpage() {
        this.page++
        this.courselist()
      },
      // 点击了上一页时触发的方法
      prevpage() {
        this.page--
        this.courselist()
      },
      // page被改变时触发的方法
      currentchange(event) {
        this.page = event
        this.courselist()
      },
      filterchange() {
        this.filter.id = 99
        this.filter.name = "789"
        this.filter.aaaa = "789"
        this.courselist()
      },
      getSelect() {
        getSelect().then(res => {
          this.filterList = res.data.map(item => {
            item.select = 0
            item.value[0]=''
            return item
          })
        })
      }
    },
    created() {
      console.log(this.$router)
      // if(this.$router.query.type==1){
      //   this.traininglist()
      // }else if(this.$router.query.type==2){
      //   this.courseshow=false
      //   this.courselist()
      // }
      this.courselist()
      this.getSelect()
    },
    beforeUpdate() {
      // this.courselist()
    }
  }
</script>

<style>
  @import url('../../assets/css/home.css');

  html {
    height: 100%;
  }

  body {
    padding: 0px;
    margin: 0px;
    height: 100%;
  }


  .bg {
    background: url('../../assets/study_bg.png') no-repeat top;
    padding-top: 1px;
    background-size: 1920px 400px;
    width: 1290px;
    height: auto;
    position: relative;
    margin: auto;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .swiper {
    width:70%;
    height: auto;
    margin: 60px auto 0 auto;
  }

  .el-carousel__indicators--outside {
    height: 22px;
    line-height: 22px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 25px 25px 25px 25px;
    width: 100px;
    margin: 0 auto;

  }

  .el-carousel__indicators--outside button {
    width: 7px;
    height: 7px;
    opacity: 1;
    border: 1px solid #FFFFFF;
    background: transparent;
    border-radius: 100%;
  }

  .el-carousel__indicator.is-active button {
    background: #FFFFFF;
  }

  .el-carousel--horizontal {
    overflow: hidden;
  }

  .el-carousel__container {
    height: 400px !important;
  }

  .el-carousel__indicator--horizontal {
    padding: 0 4px;
  }
  .el-tag{margin-right: 20px;cursor: pointer;}
  .el-tag--plain.el-tag--info{border: none;}
</style>



// WEBPACK FOOTER //
// src/pages/home/courseware.vue